import { jsx as o } from "react/jsx-runtime";
import { c as g } from "../index-rKuIKazb.js";
import h from "../Button/index.js";
import k from "../Link/index.js";
import '../assets/index21.css';const _ = "_layout_csyd0_2", L = {
  layout: _
}, j = (s) => {
  const {
    className: r,
    children: e,
    CustomLink: l,
    dataAaa: n,
    dataProductSlug: c,
    disabled: t,
    href: a,
    rel: m,
    secondary: i,
    size: u,
    target: d,
    theme: y,
    to: f
  } = s, p = a ? "_blank" : d;
  return /* @__PURE__ */ o(
    k,
    {
      className: g(L.layout, r),
      CustomLink: l,
      dataAaa: n,
      dataProductSlug: c,
      disabled: t,
      href: a,
      rel: m,
      target: p,
      to: f,
      children: /* @__PURE__ */ o(h, { disabled: t, secondary: i, size: u, theme: y, children: e })
    }
  );
};
export {
  j as default
};
